export default __webpack_public_path__ + "static/media/library-lsbd.99fbdc1c.jpg";